/**
 * Ritual Members Hooks
 * Hooks for fetching ritual members and follow/unfollow functionality
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import {
  followUser as followUserApi,
  unfollowUser as unfollowUserApi,
} from "../../profile/services/follow.service"
import { getRitualMembers, getRitualSavedUsers } from "../services/ritual.service"

export function useRitualMembers(ritualId: string, page: number = 1, limit: number = 20) {
  return useQuery({
    queryKey: ["ritual", ritualId, "members", page],
    queryFn: () => getRitualMembers(ritualId, page, limit),
  })
}

export function useRitualSavedUsers(ritualId: string, page: number = 1, limit: number = 20) {
  return useQuery({
    queryKey: ["ritual", ritualId, "saved-users", page],
    queryFn: () => getRitualSavedUsers(ritualId, page, limit),
  })
}

export function useFollowUser() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (userId: string) => followUserApi(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ritual"] })
    },
    onError: () => {
      toast.error("Failed to follow user")
    },
  })

  return {
    followUser: mutation.mutate,
    isFollowing: mutation.isPending,
  }
}

export function useUnfollowUser() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (userId: string) => unfollowUserApi(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ritual"] })
    },
    onError: () => {
      toast.error("Failed to unfollow user")
    },
  })

  return {
    unfollowUser: mutation.mutate,
    isUnfollowing: mutation.isPending,
  }
}
